import { Box, Button, Link, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { formatTimeLeft, useSupportLogging } from './useSupportLogging';

/**
 * Shown in the admin header on every page while the admin's own "Capture my logs" window runs:
 * the time left (linking to Settings -> Support) and a Stop button, so it is never on unseen.
 */
const SupportLoggingIndicator: React.FC = () => {
  const { active, secondsLeft, busy, setEnabled } = useSupportLogging();
  if (!active) return null;

  return (
    <Box
      data-testid="support-logging-indicator"
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}
    >
      <Link
        component={RouterLink}
        to="/settings?tab=support"
        underline="hover"
        color="text.secondary"
      >
        <Typography variant="caption">Logging · {formatTimeLeft(secondsLeft)}</Typography>
      </Link>
      <Button
        size="small"
        variant="text"
        disabled={busy}
        onClick={() => void setEnabled(false)}
        sx={{ minWidth: 0, py: 0, px: 0.5, fontSize: '0.75rem', textTransform: 'none' }}
      >
        Stop
      </Button>
    </Box>
  );
};

export default SupportLoggingIndicator;
